import { memo } from 'react';
import { Box } from '@mui/material';
import NavItem from './NavItem';

interface NavItemProps {
  item: {
    id: string;
    url: string;
    target?: string;
    external?: boolean;
    disabled?: boolean;
    icon?: string;
    title: string;
    chip?: {
      color: 'primary' | 'secondary';
      variant: 'filled' | 'outlined';
      size: 'small' | 'medium';
      label: string;
      avatar?: React.ReactNode;
    };
  };
  level: number;
  activeItemId: string;
  onToggle: (id: string, items: any) => void;
}

const NestedItem = memo<NavItemProps>(function NestedItem({
  item,
  level,
  activeItemId,
  onToggle,
}) {
  return (
    <Box component="div">
      <NavItem
        item={item}
        key={item.id}
        level={level}
        activeItemId={activeItemId}
        onToggle={onToggle}
      />
    </Box>
  );
});

NestedItem.displayName = 'NestedItem';

export default NestedItem;
